exports.iframeResizer = require('./iframeResizer');
exports.iframeResizerContentWindow = require('./iframeResizer.contentWindow');



//////////////////
// WEBPACK FOOTER
// ./~/iframe-resizer/src/index.js
// module id = 1135
// module chunks = 0